import {Input} from 'x.vue.mixins';
import {heatedCatalog} from 'app.vue.mixins';
import {Toggler} from 'x.vue.components.ui'
import {TileSelector} from 'app.vue.components.tileselector'

export const Shinglaselector = {
    mixins: [Input,heatedCatalog],
    components: {toggler:Toggler, TileSelector: TileSelector},
    props: {
        defaulttileid: {default: 0},
        templateurl: {default: false},
    },
    data () {
        return {
            form: {
                qlayers: 'singlelayer',
                collectionid: 0
            },
            selectedTile: false
        }
    },
    created () {
        if (this.modelValue) {
            this.reload(this.modelValue);
        } else if (true) {
            this.reload();
            
        }
    },
    mounted () {

    },
    computed: {

        // отображаемые коллекции
        showCollections ()
        {
            let showCollections = {};

            if (this.references?.pattern && this.tiles) {
                for (let TileId in this.tiles) {
                    let tile = this.tiles[TileId];
                    if (typeof showCollections[tile.COLLECTION.ID] == 'undefined') {
                        if (this.form.qlayers == 'singlelayer' 
                                && this.references.pattern[tile.PROPERTY_PATTERN_VALUE].UF_LAYERSCNT == 1
                            ) {
                            showCollections[tile.COLLECTION.ID] = tile.COLLECTION;
                        } else if (this.form.qlayers == 'multilayer' 
                                && this.references.pattern[tile.PROPERTY_PATTERN_VALUE].UF_LAYERSCNT > 1
                            ) {
                                showCollections[tile.COLLECTION.ID] = tile.COLLECTION;
                        }
                    }
                }
            }

            return showCollections;
        },

        sortedCollection() {
            console.log(this.sortObj(this.showCollections, 'SORT'));
            return this.sortObj(this.showCollections, 'SORT');
        },

        collection ()
        {
            if (this.form.collectionid && this.collections) return this.collections[this.form.collectionid];
        },

        showTiles ()
        {
            let showTiles = false;

            if (this.collection && this.tiles) {
                showTiles = [];
                for (let I in this.collection.TILES_ID) {
                    let TileId = this.collection.TILES_ID[I];

                    let tile = this.tiles[TileId];

                    if (this.form.qlayers == 'singlelayer'
                            && this.references.pattern[tile.PROPERTY_PATTERN_VALUE].UF_LAYERSCNT == 1
                        ) {
                        //showTiles[tile.ID] = tile;
                        showTiles.push(tile);
                    } else if (this.form.qlayers == 'multilayer' 
                            && this.references.pattern[tile.PROPERTY_PATTERN_VALUE].UF_LAYERSCNT > 1
                        ) {
                        //showTiles[tile.ID] = tile;
                        showTiles.push(tile);
                    }
                }
                if (!showTiles.length) return false;
            }


            return showTiles;
        }
    },
    methods: {
        sortObj(obj, key) {
            return Object.keys(obj).sort(function(a, b)
            {
                let x = Number(obj[a][key]),
                    y = Number(obj[b][key]);
                return ((x > y) ? -1 : ((x < y) ? 1 : 0));
            });
        },
        setCollection (id)
        {
            this.form.collectionid = id;
        },
        reload (tile,callcnt)
        {
            callcnt = callcnt || 0;
            callcnt++;
            if (this.tiles && this.references?.pattern) {

                if (tile) {

                    this.selectedTile = tile;

                    this.form.collectionid = tile.COLLECTION.ID;

                    if (this.references.pattern[tile.PROPERTY_PATTERN_VALUE].UF_LAYERSCNT == 1) {
                        this.form.qlayers = 'singlelayer';
                    } else if (this.references.pattern[tile.PROPERTY_PATTERN_VALUE].UF_LAYERSCNT > 1) {
                        this.form.qlayers = 'multilayer';
                    } else {
                        this.form.qlayers = undefined;
                    }
                } else {
                    this.valueModel = 0;
                    if (this.defaulttileid) {
                        for (let i in this.tiles) {
                            if (this.tiles[i].ID == this.defaulttileid) {
                                this.reload(this.tiles[i],callcnt);
                                return;
                            }
                        }
                    }
                }
                
            } else {
                
                if (callcnt < 200) {
                    setTimeout(() => {this.reload(tile,callcnt)},100);
                } else {
                    console.error('устал ждать загрузки каталога');
                }
            }
        },
        numWord(value, words){
            value = Math.abs(value) % 100;
            let num = value % 10;
            if(value > 10 && value < 20) return words[2];
            if(num > 1 && num < 5) return words[1];
            if(num === 1) return words[0];
            return words[2];
        }
    },
    watch: {

        selectedTile: {
            handler(val, oval) {
                if (this.valueModel != val) this.valueModel = val;
            },
            deep: true
        },

        modelValue (val,oval)
        {
            if (val != this.selectedTile) {
                this.reload(val);
            }

            // установка url
            if (this.templateurl && this.modelValue?.ID) {
                let url = this.templateurl.replace('#ID#',this.modelValue.ID);
                history.pushState({}, "", url);
            }
        }
    },
	template: `
	<div class="tn-shinglaselector">
        <header>
            <h3>Коллекция</h3>

            <toggler
                    v-model="form.qlayers"
                    value1="singlelayer" title1="Однослойная"
                    value2="multilayer" title2="Многослойная"
                />
            
        </header>
        <div class="selection-main-navigation">

            <div class="selection-main-navigation__wrapper swiper" ref="">
                <ul class="main-collection-in__list swiper-wrapper">
                    <li
                            v-for="item in sortedCollection"
                            v-bind:class="{'active': item == form.collectionid}"
                        > 
                        <a class="main-collection-in__link" 
                                v-bind:href="showCollections[item].DETAIL_PAGE_URL" 
                                v-on:click.prevent="setCollection(item)"
                            >
                            <span class="main-collection-in__text">{{showCollections[item].NAME}}</span>
                            <span class="main-collection-in__color">{{showCollections[item].TILES_ID.length}} {{ numWord(showCollections[item].TILES_ID.length, ['цвет', 'цвета', 'цветов']) }}</span>
                        </a>
                    </li>
                </ul>
            </div>

            <TileSelector
                    v-if="showTiles"
                    v-bind:tiles="showTiles"
                    v-model="selectedTile"
                />
        </div>
    </div>
	`
}
